import Audio from "@frog/source/utility/Audio.js"

export default {
    "slug": "pirates",
    "title": "This Be Mutiny!",
    "titleMusicKey": "Pirate:Music:MorningTide",
    "introduction": "An adventure to the high seas",
    "firstChapterKey": "ship",
    "player": require("./player.js").default,
    "chapters": {
        "ship": require("./ship").default,
        "wild": require("./wild").default,
        // "tavern": require("./tavern").default,
        // "prison": require("./prison").default,
        // "storm": require("./storm").default,
        "volcano": require("./volcano").default,

    },
    "configuration": {
        "darkness": false,
        "squigglevision": false,
        "hasColoredHealthBars": true,
    },
    "overworld": {
        "image": require("@frog/source/assets/images/pirate-tactics/overworld.map.png"),
        "locations": {
            "1": {
                "key": "1",
                "position": {"x": 2, "y": 1},
                "chapterKey": "wild",
                "isDisplayed": true,
                "isReachable": true,
            },
            "2": {
                "key": "2",
                "position": {"x": 3, "y": 3},
                "chapterKey": "ship",
            },
            "3": {
                "key": "3",
                "position": {"x": 5, "y": 3},
                "chapterKey": "prison",
            },
            "4": {
                "key": "4",
                "position": {"x": 4, "y": 5},
                "chapterKey": "tavern",
            },
        }
    },
    "audio": {
        "Pirate:Music:MorningTide": {
            "volume": 0.4,
            "label": "music",
            "kill": {"label": "music"},
            "audio": new Audio(require("@frog/source/assets/audio/pirate-tactics/new/tbm_MorningTide_V2_MIX_loop.wav"))
        },
        "Pirate:Music:PirateHaven": {
            "volume": 0.4,
            "label": "music",
            "kill": {"label": "music"},
            "mustBeLoaded": true,

            "type": "sequence:march",
            "audio": [
                new Audio(require("@frog/source/assets/audio/pirate-tactics/new/tbm_Pirate_Haven_V2_Intro.wav")),
                new Audio(require("@frog/source/assets/audio/pirate-tactics/new/tbm_Pirate_Haven_V2_Loop.wav"))
            ],
        },
        "Pirate:Music:TreasureIsland": {
            "volume": 0.33,
            "label": "music",
            "kill": {"label": "music"},

            "type": "sequence:march",
            "audio": [
                new Audio(require("@frog/source/assets/audio/pirate-tactics/new/tbm_Treasure_Island_V2_WIP.mp3"))
            ],
        },
        "Pirate:Music:Mutiny": {
            "volume": 0.4,
            "label": "music",
            "kill": {"label": "music"},

            "type": "sequence:march",
            "audio": [
                new Audio(require("@frog/source/assets/audio/pirate-tactics/new/tbm_MUTINY_V5_Intro.wav")),
                new Audio(require("@frog/source/assets/audio/pirate-tactics/new/tbm_MUTINY_V5_Loop.wav"))
            ],
        },
        "Pirate:Music:SinkingShip": {
            "volume": 0.4,
            "label": "music",
            "kill": {"label": "music"},

            "type": "sequence:march",
            "audio": [
                new Audio(require("@frog/source/assets/audio/pirate-tactics/new/tbm_Sinking_Ship_V2_Intro.wav")),
                new Audio(require("@frog/source/assets/audio/pirate-tactics/new/tbm_Sinking_Ship_V2_Loop.wav"))
            ],
        },
        "Pirate:Music:Tavern": {
            "volume": 0.3,
            "label": "music",
            "kill": {"label": "music"},
            "type": "sequence:march",
            "audio": [
                new Audio(require("@frog/source/assets/audio/pirate-tactics/new/MUSCLoop_Music Loop Song A Full Musical Stinger Tavern Interior Song 01_ESM_PG.wav"))
            ],
        },
        "Pirate:Stinger:Opening": {
            "volume": 0.5,
            "label": "music",
            "kill": {"label": "music"},
            // "audio": new Audio(require("@frog/source/assets/audio/pirate-tactics/stingers/UIAlert_Notification Musical Stinger Quest Start Confident Accordion Guitars 01_ESM_PG.wav"))
            "audio": new Audio(require("@frog/source/assets/audio/pirate-tactics/stingers/UIAlert_Notification Musical Stinger Quest Start Confident Full Orchesta Percussion 01_ESM_PG.wav"))
        },
        "Pirate:Stinger:Opening:Dramatic": {
            "volume": 0.35,
            "label": "music",
            "kill": {"label": "music"},
            "audio": new Audio(require("@frog/source/assets/audio/pirate-tactics/stingers/UIAlert_Notification Musical Stinger Quest Start Meditative Orchestral Drums Accordion 01_ESM_PG.wav"))
        },
        "Pirate:Stinger:Opening:Creepy": {
            "volume": 0.35,
            "label": "music",
            "kill": {"label": "music"},
            "audio": new Audio(require("@frog/source/assets/audio/pirate-tactics/stingers/UIAlert_Notification Musical Stinger Quest Start Neutral Mysterious Accordion Keys 01_ESM_PG.wav"))
        },
        "Pirate:Stinger:Opening:Finale": {
            "volume": 0.35,
            "label": "music",
            "kill": {"label": "music"},
            "audio": new Audio(require("@frog/source/assets/audio/pirate-tactics/stingers/UIAlert_Notification Musical Stinger Quest Start Valiant Snare Strings Brass Horns 01_ESM_PG.wav"))
        },
        "Pirate:Stinger:Failure": {
            "volume": 0.35,
            "label": "music",
            "kill": {"label": "music"},
            "audio": new Audio(require("@frog/source/assets/audio/pirate-tactics/stingers/UIAlert_Notification Musical Stinger Mission Quest Fail Pitch Drop Accordion Guitar 01_ESM_PG.wav"))
        },
        "Pirate:Stinger:Victory": {
            "volume": 0.35,
            "label": "music",
            "kill": {"label": "music"},
            "audio": new Audio(require("@frog/source/assets/audio/pirate-tactics/stingers/UIAlert_Notification Musical Stinger Fanfare Achievement Victory Celebratory Orchestral 01_ESM_PG.wav"))
        },
        "Pirate:Stinger:Victory:Dark": {
            "volume": 0.35,
            "label": "music",
            "kill": {"label": "music"},
            "audio": new Audio(require("@frog/source/assets/audio/pirate-tactics/stingers/UIAlert_Notification Musical Stinger Fanfare Achievement Victory Celebratory Orchestral 04_ESM_PG.wav"))
        },
        "Pirate:Ambience:Boat": {
            "volume": 0.2,
            "loop": true,
            "label": "ambience",
            "kill": {"label": "ambience"},
            "audio": new Audio(require("@frog/source/assets/audio/pirate-tactics/ambience/AMBSea_Ambience Loop Dock Water Boat Wood Creak Sea Wind Waves Blowing 01_ESM_PG.wav")),
            "mustBeLoaded": true,
        },
        "Pirate:Ambience:Beach": {
            "volume": 0.2,
            "loop": true,
            "label": "ambience",
            "kill": {"label": "ambience"},
            "audio": new Audio(require("@frog/source/assets/audio/pirate-tactics/ambience/AMBSea_Ambience Loop Island Land Sand Winds Foliage Daytime Forest Bird Chirp Sing 01_ESM_PG.wav")),
        },
        "Pirate:Ambience:Prison": {
            "volume": 0.2,
            "loop": true,
            "label": "ambience",
            "kill": {"label": "ambience"},
            "audio": new Audio(require("@frog/source/assets/audio/pirate-tactics/ambience/FIREBurn_Ambience Loop Fort Cannon Fire Distance Flames Crackle Metal Movement Shots 01_ESM_PG.wav")),
        },
        "Pirate:Ambience:CalmBeforeStorm": {
            "volume": 0.2,
            "loop": true,
            "label": "ambience",
            "kill": {"label": "ambience"},
            "audio": new Audio(require("@frog/source/assets/audio/pirate-tactics/ambience/AMBUndr_Ambience Loop Cave Natural Water Drips Waves Outside Storm Night Thunder Wind 01_ESM_PG.wav")),
        },
        "Pirate:Ambience:Storm": {
            "volume": 0.2,
            "loop": true,
            "label": "ambience",
            "kill": {"label": "ambience"},
            "audio": new Audio(require("@frog/source/assets/audio/pirate-tactics/ambience/AMBSea_Ambience Loop Island Sea Storm Heavywaves Strongwinds Daytime Thunder Rumble 01_ESM_PG.wav")),
        },
        "Pirate:Ambience:Volcano1": {
            "volume": 0.2,
            "loop": true,
            "label": "ambience",
            "kill": {"label": "ambience"},
            "audio": new Audio(require("@frog/source/assets/audio/pirate-tactics/ambience/AMBUndr_Ambience Loop Cave Natural Stone Debris Falling Hissing Daytime Low Rumble 01_ESM_PG.wav")),
        },
        "Pirate:Ambience:Volcano2": {
            "volume": 0.2,
            "loop": true,
            "label": "ambience",
            "kill": {"label": "ambience"},
            "audio": new Audio(require("@frog/source/assets/audio/pirate-tactics/ambience/FIREBurn_Ambience Loop Island Volcano Lava Burn Large Swell Flames Burning Crackle 01_ESM_PG.wav")),
        },

        // "Pirate:Music:Combat:1": {
        //     "volume": 0.2,
        //     "label": "music",
        //     "kill": {"label": "music"},
        //
        //     "type": "sequence:loop",
        //     "audio": new Audio(require("@frog/source/assets/audio/borrowed/asscreed4-highseas.mp3")),
        //
        // },
        // "Pirate:Music:Combat:2": {
        //     "volume": 0.2,
        //     "label": "music",
        //     "kill": {"label": "music"},
        //
        //     "type": "sequence:loop",
        //     "audio": new Audio(require("@frog/source/assets/audio/borrowed/asscreed4-piratesbeware.mp3")),
        // },
        // "Pirate:Music:Combat:3": {
        //     "volume": 0.2,
        //     "label": "music",
        //     "kill": {"label": "music"},
        //
        //     "type": "sequence:loop",
        //     "audio": new Audio(require("@frog/source/assets/audio/borrowed/sot-piratelife.mp3")),
        // },
        // "Music:Menu": {
        //     "volume": 0.37,
        //     "label": "music",
        //     "type": "sequence:loop",
        //     "audio": new Audio(require("@frog/source/assets/audio/pirate-tactics/menu.wav")),
        //     "kill": {"label": "music"},
        // },
        // "Music:Combat:Normal": {
        //     "volume": 0.37,
        //     "label": "music",
        //     "type": "sequence:loop",
        //     "audio": new Audio(require("@frog/source/assets/audio/pirate-tactics/combat1.wav")),
        //     "kill": {"label": "music"},
        // },
        // "Music:Combat:Epic": {
        //     "volume": 0.37,
        //     "label": "music",
        //     "type": "sequence:loop",
        //     "audio": new Audio(require("@frog/source/assets/audio/pirate-tactics/combat2.wav")),
        //     "kill": {"label": "music"},
        // },


        // "Selection:Start": {
        //     "volume": 0.2,
        //     "type": "once:randomly",
        //     "audio": [
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/ui/UIMvmt_UI Paper Friction Flip Turn Swipe Scratch Friction Sweep Short 01_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/ui/UIMvmt_UI Paper Friction Flip Turn Swipe Scratch Friction Sweep Short 02_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/ui/UIMvmt_UI Paper Friction Flip Turn Swipe Scratch Friction Sweep Short 03_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/ui/UIMvmt_UI Paper Friction Flip Turn Swipe Scratch Friction Sweep Short 04_ESM_PG.wav")),
        //     ],
        // },
        // "Selection:Finish": {
        //     "volume": 0,
        // },
        // "Selection:Move": {
        //     "volume": 0,
        //     "type": "once:randomly",
        //     "audio": [
        //         // new Audio(require("@frog/source/assets/audio/pirate-tactics/ui/UIClick_UI Button Glass Fast Double Tap Neutral Plop Scratch Hit 01_ESM_PG.wav")),
        //         // new Audio(require("@frog/source/assets/audio/pirate-tactics/ui/UIClick_UI Button Glass Fast Double Tap Neutral Plop Scratch Hit 02_ESM_PG.wav")),
        //         // new Audio(require("@frog/source/assets/audio/pirate-tactics/ui/UIClick_UI Button Glass Fast Double Tap Neutral Plop Scratch Hit 03_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/ui/UIClick_UI Button Paper Mid Tap Small Swipe Short Marker Pen Scratch 01_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/ui/UIClick_UI Button Paper Mid Tap Small Swipe Short Marker Pen Scratch 02_ESM_PG.wav")),
        //     ],
        // },
        // "Selection:Cancel": {
        //     "volume": 0.2,
        //     "type": "once:randomly",
        //     "audio": [
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/ui/UIMvmt_UI Paper Short Tapped Low Swipe Thick Paper Leather Mid Scratch 01_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/ui/UIMvmt_UI Paper Short Tapped Low Swipe Thick Paper Leather Mid Scratch 02_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/ui/UIMvmt_UI Paper Short Tapped Low Swipe Thick Paper Leather Mid Scratch 03_ESM_PG.wav")),
        //     ],
        // },
        // "EndTurn": {
        //     "volume": 0.3,
        //     "type": "once:randomly",
        //     "audio": [
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/ui/UIClick_UI Inventory Pirate Quest Book Close Wood Cover Mid Hit Short Wet 01_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/ui/UIClick_UI Inventory Pirate Quest Book Close Wood Cover Mid Hit Short Wet 02_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/ui/UIClick_UI Inventory Pirate Quest Book Close Wood Cover Mid Hit Short Wet 03_ESM_PG.wav")),
        //     ],
        // },
        // "UndoAction": {
        //     "volume": 0.2,
        //     "type": "once:randomly",
        //     "audio": [
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/ui/PAPRHndl_Item Action Collect Paper Pocket Hand Guide Map Open Nearfield Unfurl 01_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/ui/PAPRHndl_Item Action Collect Paper Pocket Hand Guide Map Open Nearfield Unfurl 02_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/ui/PAPRHndl_Item Action Collect Paper Pocket Hand Guide Map Open Nearfield Unfurl 03_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/ui/PAPRHndl_Item Action Collect Paper Pocket Hand Guide Map Open Nearfield Unfurl 04_ESM_PG.wav")),
        //     ]
        // },
        // "Unit:Attack:Melee": {
        //     "volume": 0,
        // },
        // "Unit:Attack:Sword": {
        //     "volume": 0.4,
        //     "type": "once:rotation",
        //     "audio": [
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/weapons/swords/GOREStab_Weapons Melee Sword Gore Blade Slice Blood Squelch Bleed Cut Swing Hit 01_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/weapons/swords/GOREStab_Weapons Melee Sword Gore Blade Slice Blood Squelch Bleed Cut Swing Hit 02_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/weapons/swords/GOREStab_Weapons Melee Sword Gore Blade Slice Blood Squelch Bleed Cut Swing Hit 03_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/weapons/swords/GOREStab_Weapons Melee Sword Gore Blade Slice Blood Squelch Bleed Cut Swing Hit 04_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/weapons/swords/GOREStab_Weapons Melee Sword Gore Blade Slice Blood Squelch Bleed Cut Swing Hit 05_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/weapons/swords/GOREStab_Weapons Melee Sword Gore Blade Slice Blood Squelch Bleed Cut Swing Hit 06_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/weapons/swords/GOREStab_Weapons Melee Sword Gore Blade Slice Blood Squelch Bleed Cut Swing Hit 07_ESM_PG.wav")),
        //     ]
        // },
        // "Unit:Attack:Spear": {
        //     "volume": 0.4,
        //     "type": "once:rotation",
        //     "audio": [
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/weapons/spears/WEAPSwrd_Weapons Melee Sword Blade Sword Brandish Metal Slide Ring Pull Out 01_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/weapons/spears/WEAPSwrd_Weapons Melee Sword Blade Sword Brandish Metal Slide Ring Pull Out 02_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/weapons/spears/WEAPSwrd_Weapons Melee Sword Blade Sword Brandish Metal Slide Ring Pull Out 03_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/weapons/spears/WEAPSwrd_Weapons Melee Sword Blade Sword Brandish Metal Slide Ring Pull Out 04_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/weapons/spears/WEAPSwrd_Weapons Melee Sword Blade Sword Brandish Metal Slide Ring Pull Out 05_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/weapons/spears/WEAPSwrd_Weapons Melee Sword Blade Sword Brandish Metal Slide Ring Pull Out 06_ESM_PG.wav")),
        //     ]
        // },
        // "Unit:Attack:Axe": {
        //     "volume": 0.4,
        //     "type": "once:rotation",
        //     "audio": [
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/weapons/clubs/GOREBone_Weapons Melee Gore Belaying Pin Wood Brass Club Solid Thud Crunch Squelch 01_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/weapons/clubs/GOREBone_Weapons Melee Gore Belaying Pin Wood Brass Club Solid Thud Crunch Squelch 02_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/weapons/clubs/GOREBone_Weapons Melee Gore Belaying Pin Wood Brass Club Solid Thud Crunch Squelch 03_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/weapons/clubs/GOREBone_Weapons Melee Gore Belaying Pin Wood Brass Club Solid Thud Crunch Squelch 04_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/weapons/clubs/GOREBone_Weapons Melee Gore Belaying Pin Wood Brass Club Solid Thud Crunch Squelch 05_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/weapons/clubs/GOREBone_Weapons Melee Gore Belaying Pin Wood Brass Club Solid Thud Crunch Squelch 06_ESM_PG.wav")),
        //     ]
        // },
        // "Unit:Attack:Gun": {
        //     "volume": 0.4,
        //     "type": "once:rotation",
        //     "audio": [
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/weapons/gun/GUNAntq_Weapons Flintlock Gun Pistol Small Caliber Blast Mechanism Near Dry Quick Shot 01_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/weapons/gun/GUNAntq_Weapons Flintlock Gun Pistol Small Caliber Blast Mechanism Near Dry Quick Shot 02_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/weapons/gun/GUNAntq_Weapons Flintlock Gun Pistol Small Caliber Blast Mechanism Near Dry Quick Shot 03_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/weapons/gun/GUNAntq_Weapons Flintlock Gun Pistol Small Caliber Blast Mechanism Near Dry Quick Shot 04_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/weapons/gun/GUNAntq_Weapons Flintlock Gun Pistol Small Caliber Blast Mechanism Near Dry Quick Shot 05_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/weapons/gun/GUNAntq_Weapons Flintlock Gun Pistol Small Caliber Blast Mechanism Near Dry Quick Shot 06_ESM_PG.wav")),
        //     ]
        // },
        // "Unit:Attack:Bow": {
        //     "volume": 0.4,
        //     "type": "once:rotation",
        //     "audio": [
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/weapons/bow/WEAPArro_Weapons Archery Projectile Arrow Bullet Whir Whiz Impact Squelch Gore 01_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/weapons/bow/WEAPArro_Weapons Archery Projectile Arrow Bullet Whir Whiz Impact Squelch Gore 02_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/weapons/bow/WEAPArro_Weapons Archery Projectile Arrow Bullet Whir Whiz Impact Squelch Gore 03_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/weapons/bow/WEAPArro_Weapons Archery Projectile Arrow Bullet Whir Whiz Impact Squelch Gore 04_ESM_PG.wav")),
        //     ]
        // },
        // "Unit:Attack:Daggers": {
        //     "volume": 0.4,
        //     "type": "once:rotation",
        //     "audio": [
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/weapons/daggers/WEAPSwrd_Weapons Melee Sword Wood Sharp Slash Cut Short Slice Swipe Swing Quick 01_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/weapons/daggers/WEAPSwrd_Weapons Melee Sword Wood Sharp Slash Cut Short Slice Swipe Swing Quick 02_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/weapons/daggers/WEAPSwrd_Weapons Melee Sword Wood Sharp Slash Cut Short Slice Swipe Swing Quick 03_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/weapons/daggers/WEAPSwrd_Weapons Melee Sword Wood Sharp Slash Cut Short Slice Swipe Swing Quick 04_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/weapons/daggers/WEAPSwrd_Weapons Melee Sword Wood Sharp Slash Cut Short Slice Swipe Swing Quick 05_ESM_PG.wav")),
        //     ]
        // },
        // "Unit:Attack:FinalHit": {
        //     "volume": 0,
        // },
        // "Unit:Attack:NoDamage": {
        //     "volume": 0,
        // },
        // "Unit:Heal": {
        //     "volume": 0.3,
        //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Heal.ogg")),
        // },
        // "Unit:Death": {
        //     "volume": 0.3,
        //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Death.ogg")),
        // },
        // "Unit:Move": {
        //     "volume": 0.1,
        //     "type": "once:randomly",
        //     "audio": [
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/footsteps/FEETHmn_Footstep Wood Thud Deck Neutral Surface Low Resonant Walk 01_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/footsteps/FEETHmn_Footstep Wood Thud Deck Neutral Surface Low Resonant Walk 02_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/footsteps/FEETHmn_Footstep Wood Thud Deck Neutral Surface Low Resonant Walk 03_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/footsteps/FEETHmn_Footstep Wood Thud Deck Neutral Surface Low Resonant Walk 04_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/footsteps/FEETHmn_Footstep Wood Thud Deck Neutral Surface Low Resonant Walk 05_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/footsteps/FEETHmn_Footstep Wood Thud Deck Neutral Surface Low Resonant Walk 06_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/footsteps/FEETHmn_Footstep Wood Thud Deck Neutral Surface Low Resonant Walk 07_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/footsteps/FEETHmn_Footstep Wood Thud Deck Neutral Surface Low Resonant Walk 08_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/footsteps/FEETHmn_Footstep Wood Thud Deck Neutral Surface Low Resonant Walk 09_ESM_PG.wav")),
        //         new Audio(require("@frog/source/assets/audio/pirate-tactics/footsteps/FEETHmn_Footstep Wood Thud Deck Neutral Surface Low Resonant Walk 10_ESM_PG.wav")),
        //     ]
        // },
    },
    "credits": [
        "Andrew Goodenough",
        "Doc McPherson",
        "Anna Arkhipova",
        "Vitor Amado",
    ]
}
